import { useState, useEffect, useRef } from 'react';
export default function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const ref = useRef(null);
    const refTarget = useRef(null);
    const handleClickOutside = (event) => {
        if (refTarget.current) {
            if (ref.current &&
                !ref.current.contains(event.target) &&
                refTarget.current &&
                !refTarget.current.contains(event.target)) {
                setIsComponentVisible(false);
            }
        }
        else {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsComponentVisible(false);
            }
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside, true);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    });
    return { ref, isComponentVisible, setIsComponentVisible, refTarget };
}
